// ConfirmModal.jsx - Reusable confirmation modal
import React from "react";
import "./ConfirmModal.css";

function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  type = "danger"
}) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={handleCancel}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-labelledby="modal-title"
      aria-describedby="modal-message"
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 id="modal-title">{title}</h2>
          <button
            className="modal-close"
            onClick={handleCancel}
            aria-label="Close dialog"
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <p id="modal-message">{message}</p>
        </div>

        <div className="modal-footer">
          <button
            className={`modal-button cancel ${type}`}
            onClick={handleCancel}
          >
            {cancelText}
          </button>
          <button
            className={`modal-button confirm ${type}`}
            onClick={handleConfirm}
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
